import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = '';

export const getContractSlice = createSlice({
 name: 'getContract',
 initialState,
 reducers: {
  getContract: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { getContract } = getContractSlice.actions;

export default getContractSlice.reducer;
